import { MainWindowManager } from '@front/controls/UtilsClasses/MainWindowManager';
import { WorkSpaceManager } from '@front/controls/WorkSpace/WorkSpaceManager';
import { Control } from '@front/controls/elements/Control';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
export function GlobalAnimationFrameHandler() {
    DateTimeUtils.SetDateTimeNow();
    WorkSpaceManager.TickAsync();
    Control.Ticker.Raise();
    if (MainWindowManager.FullLogPanel) {
        MainWindowManager.FullLogPanel.TickAsync();
    }
    requestAnimationFrame(GlobalAnimationFrameHandler);
}
